import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";

export async function personaDetailsAPI(requestPayload) {
  try {
    return await authenticatedFetch(URL.PersonaApi, {
      method: "POST",
      body: JSON.stringify(requestPayload)
    });
  } catch (error) {
    console.error("Error fetching user:", error.message);
    throw error;
  }
}

export async function createPersonaAPI(newPersona) {
  try {
    return await authenticatedFetch(URL.AddPersonaApi, {
      method: "POST",
      body: JSON.stringify(newPersona)
    });
  } catch (error) {
    console.error("Error creating user:", error.message);
    throw error;
  }
}

export async function editPersonaAPI(updatedPersona) {
  try {
    return await authenticatedFetch(URL.EditPersonaApi, {
      method: "PUT",
      body: JSON.stringify(updatedPersona),
    });
  } catch (error) {
    console.error("Error updating user:", error.message);
    throw error;
  }
}

export async function deletePersonaAPI(personaId) {
  try {
    return await authenticatedFetch(`${URL.DeletePersonaApi}/${personaId}`, {
      method: "DELETE",
    });
  } catch (error) {
    console.error("Error deleting persona:", error.message);
    throw error;
  }
}